import React from "react";
import { useLocation } from "react-router-dom";
import { StatusBar } from "@/components/StatusBar";
import { BottomNav } from "@/components/BottomNav";

const NO_CHROME = ["/", "/auth"];

export const PhoneFrame = ({ children }) => {
  const location = useLocation();
  const bare = NO_CHROME.includes(location.pathname);

  return (
    <div className="min-h-screen bg-slate-900 dark:bg-black sm:py-6 md:py-8 flex items-center justify-center font-sans antialiased">
      <div className="w-full max-w-md mx-auto h-screen sm:h-[860px] bg-stone-50 dark:bg-emerald-950 sm:rounded-[44px] shadow-2xl overflow-hidden relative border border-slate-200/40 dark:border-emerald-800/60 flex flex-col transition-colors duration-300">
        {!bare && <StatusBar />}
        <div
          className={`flex-1 overflow-y-auto overflow-x-hidden scrollbar-none ${
            bare ? "" : "pb-24"
          }`}
        >
          {children}
        </div>
        {!bare && <BottomNav />}
      </div>
    </div>
  );
};
